import { render, staticRenderFns } from "./WebhookForm.vue?vue&type=template&id=3c2c9e5a&scoped=true&"
import script from "./WebhookForm.vue?vue&type=script&lang=js&"
export * from "./WebhookForm.vue?vue&type=script&lang=js&"
import style0 from "./WebhookForm.vue?vue&type=style&index=0&id=3c2c9e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c9e5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
